import { render, staticRenderFns } from "./st5.vue?vue&type=template&id=54ed6d71"
import script from "./st5.vue?vue&type=script&lang=js"
export * from "./st5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports